import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotyfContext from "../../../contexts/NotyfContext";

import {
  assignCatalogSimProducts,
  getCatalogSimProducts,
  getSimProducts,
} from "../../../redux/slices/sims";
// import PurchaseOrderProduct from "../../purchaseOrders/PurchaseOrderProduct";
import { Helmet } from "react-helmet-async";
import { Button, Container, Form } from "react-bootstrap";
import AssignSimProduct from "./AssignSimProduct";
import * as Yup from "yup";
import { Formik } from "formik";
import { useWhitelabel } from "../../../contexts/WhitelabelContext";
import Loader from "../../../components/spinners/Loader";

const AssignSimProducts = () => {
  const { sim_products, catalog_sim_products } = useSelector(
    (state) => state.sims
  );
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const notyf = useContext(NotyfContext);
  const { backgroundColor, fontColor } = useWhitelabel();

  const [formInitialValues, setFormInitialValues] = useState({
    simProducts: [],
  });

  console.log(sim_products, catalog_sim_products);

  useEffect(() => {
    if (!isLoading && sim_products.length) {
      const mappedSimProducts = sim_products
        .filter((product) =>
          catalog_sim_products.some(
            (catProd) => catProd.simProduct.id === product.id
          )
        )
        .map((product) => {
          const assigned = catalog_sim_products.find(
            (catProd) => catProd.simProduct.id === product.id
          );

          return {
            id: product.id,
          };
        });

      setFormInitialValues({ simProducts: mappedSimProducts });
    }
  }, [isLoading, sim_products, catalog_sim_products]);

  const validation = Yup.object({
    simProducts: Yup.array(),
  });

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  useEffect(() => {
    const fetchSimProducts = async () => {
      await Promise.all([
        dispatch(getSimProducts()),
        dispatch(getCatalogSimProducts({ type: "assign" })),
      ])
        .catch((error) => {
          notyf.open({
            type: "danger",
            message: error,
            duration: 5000,
            ripple: true,
            dismissible: false,
            position: {
              x: "center",
              y: "top",
            },
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        });
    };

    if (!!activeUser?.id) {
      fetchSimProducts();
    }
  }, [activeUser, dispatch, notyf]);

  if (isLoading) return <Loader />;
  return (
    <React.Fragment>
      <Helmet title="Assign SIM Products" />
      <Container
        fluid
        className="p-0 d-flex flex-column"
        style={{ minHeight: "100%" }}
      >
        <Formik
          initialValues={formInitialValues}
          enableReinitialize={true}
          validationSchema={validation}
          onSubmit={async (values, { setValues }) => {
            await dispatch(assignCatalogSimProducts({ data: values }))
              .then(() => {
                notyf.open({
                  type: "success",
                  message: "Sim Products assigned to catalog",
                  duration: 5000,
                  ripple: true,
                  dismissible: false,
                  position: {
                    x: "center",
                    y: "top",
                  },
                });
                setValues(formInitialValues);
                dispatch(getCatalogSimProducts({ type: "assign" }));
              })
              .catch((error) => {
                notyf.open({
                  type: "danger",
                  message: error,
                  duration: 5000,
                  ripple: true,
                  dismissible: false,
                  position: {
                    x: "center",
                    y: "top",
                  },
                });
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldTouched,
            isValid,
            dirty,
          }) => {
            return (
              <Form
                onSubmit={handleSubmit}
                className="d-flex flex-column flex-grow-1"
              >
                <div className="products-list flex-grow-1 overflow-auto">
                  {sim_products.map((product) => {
                    return (
                      <AssignSimProduct
                        product={product}
                        values={values}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        touched={touched}
                        errors={errors}
                        setFieldTouched={setFieldTouched}
                      />
                    );
                  })}
                </div>
                <div className="d-flex justify-content-end align-items-end mt-4">
                  <Button
                    type="submit"
                    disabled={!isValid || !dirty}
                    style={{
                      "--dynamic-bg-color": backgroundColor,
                      "--dynamic-font-color": fontColor,
                      border: "none",
                    }}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Container>
    </React.Fragment>
  );
};

export default AssignSimProducts;
